import { Link } from "react-router-dom";

export default function Layout({ user, onLogout, children }) {
  return (
    <div className="min-h-screen bg-ink-50">
      <header className="border-b border-ink-200 bg-white">
        <div className="mx-auto flex max-w-[1440px] items-center justify-between px-6 py-3">
          <Link to="/" className="flex items-center">
            {/* Mobile: nur Schild-Icon */}
            <img
              src="/icon_tender.png"
              alt="Tender Monitor"
              className="h-9 md:hidden"
            />
            {/* Desktop: Schild + Schriftzug */}
            <img
              src="/logopart.png"
              alt="Tender Monitor"
              className="hidden md:block h-10"
            />
          </Link>
          <div className="flex items-center gap-4">
            <span className="hidden text-sm text-ink-600 sm:block">
              {user?.name || user?.email}
            </span>
            <button onClick={onLogout} className="btn-ghost">
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1440px] px-6 py-6">{children}</main>
    </div>
  );
}
